<template>
  <Modal ref="modal" :title="type === 'create' ? 'Adicionar Produto/Serviço' : 'Editar Produto/Serviço'" :width="500"
    @cancel="close">
    <form class="form-container" @submit.prevent="handleSubmit">
      <Input :modelValue="name" @update:modelValue="$event => (name = $event)" legend="Nome do Produto/Serviço"
        :disabled="loading" />

      <Input type="currency" :modelValue="value" @update:modelValue="$event => (value = $event)"
        legend="Valor do Produto/Serviço" :disabled="loading" />

      <Button type="submit" :text="type === 'create' ? 'Adicionar' : 'Salvar'" color="primary" :disabled="loading" />
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Input from 'core/Input'
import Button from 'core/Button'

export default {
  name: 'ProdutosServicosFormModal',
  components: {
    Modal,
    Input,
    Button,
  },
  data() {
    return {
      type: 'create',
      id: '',
      name: '',
      value: 0,
      loading: false,
    }
  },
  methods: {
    open(type, product = null) {
      console.log(type, product)
      this.type = type

      if (product) {
        this.id = product.id
        this.name = product.name
        this.value = product.value
      }

      this.$refs.modal.open()
    },
    close() {
      this.type = 'create'
      this.id = ''
      this.name = ''
      this.value = 0
      this.$refs.modal.close()
    },
    async handleSubmit() {
      if (!this.name || !this.value) {
        this.$toasted.show('Por favor, preencha todos os campos.', {
          position: 'top-right',
        })

        return
      }

      this.loading = true

      const payload = {
        name: this.name,
        value: this.value,
      }

      if (this.type === 'create') {
        await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/produtos`, payload)
          .then(() => {
            this.$toasted.show('Produto/Serviço adicionado com sucesso!', {
              position: 'top-right',
            })

            this.$emit('refresh')
          })
          .catch(() => {
            this.$toasted.show('Erro ao adicionar produto/serviço.', {
              position: 'top-right',
            })
          })
          .finally(() => {
            this.loading = false
            this.close()
          })
      } else {
        await this.$http.put(`${process.env.VUE_APP_URL_API_V2}/produtos/${this.id}`, payload)
          .then(() => {
            this.$toasted.show('Produto/Serviço atualizado com sucesso!', {
              position: 'top-right',
            })
            this.$emit('refresh')
          })
          .catch((err) => {
            this.$toasted.show('Erro ao atualizar produto/serviço.', {
              position: 'top-right',
            })
            this.$toasted.show(err.body.mensagem, {
              position: 'top-right',
            })
          })
          .finally(() => {
            this.loading = false
            this.close()
          })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  button {
    justify-content: center;
  }
}
</style>